import { render, staticRenderFns } from "./indexVant组件.vue?vue&type=template&id=463f551d&scoped=true"
import script from "./indexVant组件.vue?vue&type=script&lang=js"
export * from "./indexVant组件.vue?vue&type=script&lang=js"
import style0 from "./indexVant组件.vue?vue&type=style&index=0&id=463f551d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "463f551d",
  null
  
)

export default component.exports